import { useEffect } from "react";

type KeyName =
  | "Escape"
  | "Enter"
  | "ArrowUp"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "Shift"
  | "Control"
  | "Alt"
  | "Meta";

export const useKeypress = (
  key: KeyName,
  handler: (event: KeyboardEvent) => void,
  eventName: Extract<keyof GlobalEventHandlersEventMap, "keyup" | "keydown"> = "keyup"
) => {
  useEffect(() => {
    const onKeyup = (event: KeyboardEvent) => {
      if (event.key === key) handler(event);
    };

    window.addEventListener(eventName, onKeyup);

    return () => {
      window.removeEventListener(eventName, onKeyup);
    };
  }, [key, handler]);
};
